import { Container, Col, Row } from "reactstrap";
import { BreadcrumbItem } from "reactstrap";
import * as OrganizationKeyQL from "queries/organization-key";
import * as Notify from "@repoflow/form-schema/notify";
import { CancellableContent } from "@repoflow/components/content-cancel";

import {
  Mutation,
  Button,
  useSectionContext,
} from "@repoflow/components/section";

export const Sidebar = () => null;

export const Indice = ({ match: { params } }) => (
  <>
    <BreadcrumbItem>Remove</BreadcrumbItem>
  </>
);

export const Content = ({ history, match: { params } }) => {
  const {
    parent: { base },
  } = useSectionContext();

  return (
    <CancellableContent>
      <Container className="mt-4">

        <Row>
          <Col>
            Removing the API key <b>{params.keyId}</b>? This action will be
            permanent and can't be undone
          </Col>
        </Row>
        <Mutation
          mutation={OrganizationKeyQL.remove}
          update={OrganizationKeyQL.update(params)}
          onMutate={({ handler }) => {
            handler({
              variables: params,
            });
          }}
          onCompleted={() => {
            history.replace(base);
          }}
          onError={(error) => {
            Notify.error(error.toString());
          }}
        >
          {MutationHandler}
        </Mutation>
      </Container>
    </CancellableContent>
  );
};

const MutationHandler = ({ mutate }) => {
  return (

    <Row>
      <Col>
        <Button
          onClick={() => {
            mutate();
          }}
        >
          Remove
        </Button>
      </Col>
    </Row>

  );
};
